<template>
    <app-layout>
        <template #header>
            <AppHead title="Order History" />
            <h2 class="title">Your Orders</h2>
            <flash-messages />
        </template>

        <card title="Account Statement" class="mb-3 mt-4">
            <div class="row">
                <div class="col-4">
                    <jet-label for="start_date" value="Select Start Date" />
                    <Calendar class="w-100" v-model="start_date" dateFormat="mm/dd/yy" show-icon="true" />
                </div>

                <div class="col-4">
                    <jet-label for="end_date" value="Select End Date" />
                    <Calendar class="w-100" v-model="end_date" dateFormat="mm/dd/yy" show-icon="true" />
                </div>

                <div class="col-4 text-center w-100">
                    <jet-button class="w-100" icon="fas fa-file-invoice" btnStyle="success"
                        @click="openPrintAccountActivity">Print</jet-button>
                </div>
            </div>
        </card>

        <card class="bg-white mt-4">
            <DataTable :value="orders" :paginator="true" :rows="10" stripedRows breakpoint="992px" class="p-datatable-sm"
                :rowClass="() => { return 'table-row' }"
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport"
                sortField="date" :sortOrder="-1" @row-click="(e) => $inertia.get(route('order.view', e.data.id))">
                <Column class="width-third" field="id" header="Order #">
                    <template #body="slotProps">
                        #{{ slotProps.data.id }}
                        <PaymentMethodDisplay class="ml-2" :payment_method="slotProps.data.payment.payment_method" />
                    </template>
                </Column>
                <Column field="status_desc" header="Status" :sortable="true"></Column>
                <Column field="total" header="Total" :sortable="true">
                    <template #body="slotProps">
                        {{ formatDollars(slotProps.data.total) }}
                    </template>
                </Column>
                <Column field="date" header="Date" :sortable="true">
                    <template #body="slotProps">
                        {{ moment(slotProps.data.date).format('M/D/YY h:mm A') }}
                    </template>
                </Column>
                <Column class="button-container" :exportable="false">
                    <template #body="slotProps">
                        <jet-button :goesTo="route('order.view', slotProps.data.id)" icon="fas fa-angle-right"
                            class="btn-sm" tabindex="-1">View</jet-button>
                    </template>
                </Column>
            </DataTable>
        </card>
    </app-layout>
    <teleport to="body">
        <PrintModal :printUrl="printUrl" @print="print" />
    </teleport>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout'
import FlashMessages from '@/Shared/FlashMessages'
import Icon from '@/Shared/Icon'
import PaymentMethodDisplay from '@/Components/Transaction/PaymentMethodDisplay'
import moment from 'moment'
import PrintModal from '@/Components/Modals/PrintModal'
import Calendar from "primevue/calendar";

export default {
    components: {
        AppLayout,
        FlashMessages,
        Icon,
        PaymentMethodDisplay,
        PrintModal,
        Calendar,
    },
    props: {
        user: Object,
        orders: Array,
        total_orders: Number
    },
    data() {
        return {
            currentDate: moment(),
            printUrl: '',
            start_date: moment().date(1).month('January').format('M/D/Y'),
            end_date: moment().endOf('month').format('M/D/Y'),
        }
    },
    created: function () {
        this.moment = moment;
    },
    methods: {
        openPrintAccountActivity() {
            this.printReport = 'tu.report.accountActivity'
            this.openPrintDialog();
        },
        openPrintDialog() {
            this.setPrintUrl(0);
            $('#PrintModal').modal('show');
        },
        print() {
            this.setPrintUrl(1);
        },
        setPrintUrl(print) {
            this.printUrl = this.route('tu.report.accountActivity',
                { user: this.$page.props.auth.user.id, start: this.dayStartUTC(this.start_date), end: this.dayEndUTC(this.end_date), utcOffset: moment().utcOffset(), print: print });
        },
        dayStartUTC(date) {
            return moment.utc(moment(date).startOf('day')).unix();
        },
        dayEndUTC(date) {
            return moment.utc(moment(date).endOf('day')).unix();
        },
    }
}
</script>
